
// Menu on Hover
  document.addEventListener('DOMContentLoaded', () => {

    document.addEventListener('mouseover', (e) => {
      const li = e.target.closest('.vertical li');
      if (!li) return;

      li.classList.add('hover');
    });

    document.addEventListener('mouseout', (e) => {
      const li = e.target.closest('.vertical li');
      if (!li) return;

      // 🔑 IMPORTANT: only close if mouse actually left the <li>
      if (!li.contains(e.relatedTarget)) {
        li.classList.remove('hover');
      }
    });
  });
// Menu on Hover jQuery old
  /*
    $(document).ready(function () {
      // On Hover - Opens Sub menu 
          $('.vertical li').hover( function() {
            $(this).addClass('hover');
            var str = $(this).find('a').eq(0).text();
        
          }, function() {
            $(this).removeClass('hover');
            var str = $(this).find('a').eq(0).text();

          });

    })
  */